import { useEffect, useState } from 'react';
import { ChevronDown, FileText, HelpCircle, Leaf } from 'lucide-react';
import { Html } from '../lib/htmlContent';
import { loadAbout, loadFaq, loadTerms } from '../lib/account';
import { LoadingState } from '../components/ui';

export function StudentStaticPage({ kind }: { kind: 'faq' | 'about' | 'terms' }) {
  const [content, setContent] = useState<{ faq?: Awaited<ReturnType<typeof loadFaq>>; about?: string; terms?: string }>();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    void (kind === 'faq' ? loadFaq().then((faq) => ({ faq })) : kind === 'about' ? loadAbout().then((about) => ({ about })) : loadTerms().then((terms) => ({ terms })))
      .then((value) => { if (active) setContent(value); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, [kind]);

  const hero = {
    faq: { icon: HelpCircle, title: 'FAQ', description: 'Quick answers for common learning tasks' },
    about: { icon: Leaf, title: 'About AyurGuide', description: 'Your Ayurveda learning workspace' },
    terms: { icon: FileText, title: 'Terms & conditions', description: 'The rules that keep this service clear' },
  }[kind];
  const Icon = hero.icon;

  return <div className="utility-page">
    <section className="utility-hero"><div className="utility-icon"><Icon size={28} /></div><div><h1>{hero.title}</h1><p>{hero.description}</p></div></section>
    {!content && !failed ? <LoadingState />
      : kind === 'faq'
        ? content?.faq?.length
          ? <section className="utility-list faq-list">{content.faq.map((row) => (
            <details key={row.objectId} className="faq-item">
              <summary>{row.Question}<ChevronDown size={15} /></summary>
              <Html html={row.Answer} className="faq-answer" />
            </details>
          ))}</section>
          : <p className="detail-description">No FAQ entries have been published yet.</p>
        : <section className="utility-list static-doc">{kind === 'about' ? <Html html={content?.about} /> : <Html html={content?.terms} />}</section>}
  </div>;
}
